import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { Tooltip } from "~/components/Tooltip";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const LOCKUP_PERIOD_MONTHS_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.lockupPeriodMonths,
    sortsOn: AssetColumns.lockupPeriodMonths,
    label: "Lockup Period (Months)",
    tooltip: CatalogReferenceDataSlugs.lockup_period_months,
    type: ColumnTypes.number,
    width: 180,
    cellValue: (item) => {
        if (item.isAsset) {
            return item.lockup_period_months;
        }

        return null;
    },
};

export const LOCKUP_DESCRIPTION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.lockupDescription,
    sortsOn: AssetColumns.lockupDescription,
    label: "Lockup Description",
    tooltip: CatalogReferenceDataSlugs.lockup_description,
    type: ColumnTypes.string,
    width: 320,
    render: (item) => {
        if (!item.isAsset) {
            return <Emdash />;
        }

        const value = item.lockup_description;
        if (!value) {
            return <Emdash />;
        }

        return (
            <Tooltip
                placement="top"
                tooltipContent={
                    <div className="px-3 py-2 text-sm max-w-sm whitespace-pre-line">
                        {value}
                    </div>
                }
            >
                {({ setTriggerRef }) => (
                    <span ref={setTriggerRef} className="line-clamp-2">
                        {value}
                    </span>
                )}
            </Tooltip>
        );
    },
};
